import { AppConfig } from "@typings/appConfig";
import { CURRENCY_PER_COUNTRY } from "@config/consts";
import {
  AVAILABLE_COUNTRIES,
  AVAILABLE_LANGS,
  SERVICE_TYPE,
} from "@typings/globals";
import { EXTRA_SERVICES_B2B, FREQUENCY } from "@typings/b2b";

const config: AppConfig = {
  currency: CURRENCY_PER_COUNTRY[AVAILABLE_COUNTRIES.LU],
  availableLanguages: [
    AVAILABLE_LANGS.EN,
    AVAILABLE_LANGS.FR,
    AVAILABLE_LANGS.DE,
  ],
  booking: {
    commitments: {
      enabled: false,
    },
    whatIsIncluded: {
      headers: [
        "periodicity_once",
        "periodicity_weekly",
        "periodicity_every_2_weeks",
        "periodicity_more_often",
      ],
      rows: [
        [false, true, true, false],
        [true, true, true, true],
        [true, true, true, true],
        [false, true, true, true],
        [true, true, true, true],
      ],
    },
  },
  b2b: {
    disabledExtrases: [EXTRA_SERVICES_B2B.LAUNDRY_CLOTHS],
    disabledFrequencies: [FREQUENCY.EVERY_4_WEEKS],
    duration: {
      max: 15,
      min: 2,
      minAdmin: 0.5,
      step: 0.5,
    },
  },
  refRewardAmount: 20,
  welcomeRewardAmount: 20,
  marketingConsentEnabled: true,
  legalConsentEnabled: true,
  helpCenter: {
    reportDamageUrl: {
      [AVAILABLE_LANGS.EN]:
        "https://docs.google.com/forms/d/e/1FAIpQLSc_HlPfvG5BUeSEiA-AHgPv7GGc6U-5neGAHme9hSzwxL9eNA/viewform?usp=sf_link",
      [AVAILABLE_LANGS.FR]:
        "https://docs.google.com/forms/d/e/1FAIpQLSckpBEixstryi-QV3BMzZQrHghZKIVDgIFGhi3oggNI8NapNw/viewform?usp=sf_link",
    },
  },
  availableServices: [
    SERVICE_TYPE.HOME_CLEANING,
    SERVICE_TYPE.END_OF_TENANCY,
    SERVICE_TYPE.B2B,
  ],
  legalLinksOnHomePage: true,
};

export { config as lu };
